import { sendPostRequest, API_CONFIG } from '../helper/HttpHelper'
import { camelCaseToTitle, readableDate, classNames } from './Helper';
import { useEffect, useContext, useState } from 'react'
import { AuthContext } from '../store/auth-context';
import { useNavigate } from 'react-router-dom';
import {Modal} from './Modal'
const statuses = {
  Complete: 'text-green-700 bg-green-50 ring-green-600/20',
  'In progress': 'text-gray-600 bg-gray-50 ring-gray-500/10',
  Archived: 'text-yellow-800 bg-yellow-50 ring-yellow-600/20',
}

function BuildList({listJSON}) {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate()
  const {token} = useContext(AuthContext);
  const [list, setList] = useState([]);
  const [selectedItem, setSelectedItem] = useState('')
  const [open, setOpen] = useState(false)
  const [mesg, setMesg] = useState({content:listJSON.body?.action?.content, title: listJSON.body?.action?.title, 'action':handleApproval,  button_text:'Approve', getData:getSelectedItem})
  
  // To display the confirmation box
  function handleConfirmation(item) {
    console.log('BuildList - handleConfirmation - ' + item)
    setSelectedItem(item)   
    setOpen(true)
  }

  async function handleApproval(data){
    console.log('BuildList - handling approval - ' + data)
    try{
      let res = await sendPostRequest(listJSON.body.action.endpoint, {'data': data, 'meta':{token: token} }) 
      console.log(res)
      if(res.status === 'error'){
        console.error(res.message)
        return
      }
      setOpen(false)
      setSelectedItem('')
      window.location.reload()
    }catch(e){
      console.error(e)
    }
  }
  
  function getSelectedItem(){
    return selectedItem
  }
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = {
          method: listJSON?.fetch?.method,
          data: listJSON?.fetch?.data,
          meta: token?.eid ? {
            eid: token.eid,
            username: token.username,
            token: token,
            display_name: token.display_name
          } : {}
        };
    
        const res = await sendPostRequest(listJSON.fetch.endpoint, params);
        console.log(res);
    
        if (res.status === 'error') {
          console.error(res.message);
          return;
        }
        setList(res.data);
        console.log("Setting List - " + JSON.stringify(res.data))
      } catch (e) {
        console.error(e);
      }
    };
    fetchData()
  }, [])
  return (listJSON?.template) === 'renderFeedList'?renderFeedList():renderTableList()

  function renderTableList(){
      return (
        <div className="px-4 sm:px-6 lg:px-8">
          {(open) && <Modal title={mesg.title} content={mesg.content} action={mesg.action} button_text={mesg.button_text} getData={getSelectedItem} closeModal={() => setOpen(false)}></Modal>}
          <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold text-gray-900">{listJSON.body.title}</h1>
              <p className="mt-2 text-sm text-gray-700">
                {listJSON.body.subtitle}
              </p>
            </div>
          </div>
          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      {list && list.length > 0 && Object.keys(list[0].ATTR1).map((key, index) => (
                          (!listJSON.body?.exclude?.includes(key)) &&
                          <th key={index} scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                            {camelCaseToTitle(key)}
                          </th>
                      ))}
                    </tr>
    
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {list && list.length > 0 && list.map((item, index) => (
                      <tr key={index}>
                         {Object.keys(item.ATTR1).map((key) => (
                          (!listJSON.body?.exclude?.includes(key)) && (<td key={key} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                            {listJSON.body.format?.[key] ? listJSON.body.format[key](item.ATTR1[key]): item.ATTR1[key]}
                          </td>)
                        ))}
                        {listJSON.body.action &&  (
                            <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0 space-x-2">
                              <a href="#" onClick={() => handleConfirmation(item)} className="text-indigo-600 hover:text-indigo-900">
                                {listJSON.body.action.action_text}
                              </a>
                            </td>
                        )}
                      </tr>
                        
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )
  }
  function renderFeedList(){
    function handleClick(item) {
      //console.log(JSON.stringify(loanApplication));
      navigate('#')
    }
    const renderChunks = (item) => {
      console.log('BuildList - renderChunks - ' + item)
      const attributes = Object.entries(item.ATTR1).filter(([item, index]) =>  !listJSON.body?.exclude?.includes(item[0])); ;
      const chunkSize = 4;
      const chunks = [];
      for (let i = 0; i < attributes.length; i += chunkSize) {
        const chunk = attributes.slice(i, i + chunkSize);
        chunks.push(
          <div className="mt-1 grid grid-cols-4 text-xs leading-5 text-gray-500" key={i}>
            {chunk.map(([key, value], index) => {
              const label = camelCaseToTitle(key);
              return label ? (
                <p className="whitespace-nowrap" key={index}>
                  <span className='text-xs mr-2'>{label}:</span>
                  <span className='text-sm font-bold'>{listJSON.body.format?.[key] ? listJSON.body.format[key](value): value}</span>
                </p>
              ) : null;
            })}
          </div>
        );
      }
      return chunks;
    };
    return (
        <>
        <div className="border-b border-gray-200 bg-white px-4 py-3 mb-5 sm:px-6">
            <div className="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap">
                <div className="ml-4 mt-4">
                <h3 className="text-base font-semibold leading-6 text-gray-900">{listJSON.body.title}</h3>
                <p className="mt-1 text-sm text-gray-500">
                  {listJSON.body.description}
                </p>
                </div>
                <div className="ml-4 mt-4 flex-shrink-0">
                </div>
            </div>
        </div>
        <ul
        role="list"
        className="divide-y divide-gray-100 overflow-hidden bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl"
        >
        {list && list.length > 0 && list.map((item, index) => (
            <li key={item.sk} className="relative flex justify-between gap-x-6 px-4 py-5 hover:bg-gray-50 sm:px-6 hover:cursor-pointer" onClick={() => {handleClick(item)}}>
                <div className="min-w-0">
                    {<div className="flex items-start gap-x-3 mb-3" key="1">
                        <p className="text-sm font-semibold leading-6 text-gray-900">ID: {item?.ATTR1?.id}</p>
                        <p
                        className={classNames(
                            statuses['Sanctioned'],
                            'mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset',
                        )}
                        >
                        {camelCaseToTitle(item?.ATTR1?.status)}
                        </p>
                        <div className="mt-1 flex items-center gap-x-2 text-xs leading-5 text-gray-500" key="4">
                        <p className="whitespace-nowrap italic">
                            Last Edited {readableDate(item.modified_datetime)}
                        </p>
                        <svg viewBox="0 0 2 2" className="h-0.5 w-0.5 fill-current">
                            <circle r={1} cx={1} cy={1} />
                        </svg>
                        <p className="truncate italic">Modified by {item?.ATTR1?.display_name}</p>
                        </div>
                    </div>}
                    <div className="mb-2">
                        {renderChunks(item)}
                    </div>
                </div>
            </li>
        ))}
        </ul>
        </>
    )
  }


}
export { BuildList }